import { Parser } from '~/api';
import { ServerTemplateTask } from '~/api/models';
import { useModelsStore } from '~/stores';
import RequestService from './request';

interface CreateTaskRequest {
    schedule: string;
    action: string;
    time_offset: number;
    payload?: string;
}

interface UpdateTaskRequest extends CreateTaskRequest {
    id: string;
}

interface DeleteTaskRequest {
    schedule: string;
    id: string;
}

interface ReorderTasksRequest {
    schedule: string;
    order: string[];
}

const refreshTemplate = (): void => {
    useModelsStore().refreshModel('serverTemplate');
};

class ServerTemplateTasksService {
    create(data: CreateTaskRequest): Promise<ServerTemplateTask> {
        return RequestService.post(`/server-templates/:serverTemplate/schedules/${data.schedule}/tasks`, data)
            .then(Parser.parse)
            .then((task: ServerTemplateTask) => {
                refreshTemplate();

                return task;
            });
    }

    update(data: UpdateTaskRequest): Promise<ServerTemplateTask> {
        return RequestService.put(`/server-templates/:serverTemplate/schedules/${data.schedule}/tasks/${data.id}`, data)
            .then(Parser.parse)
            .then((task: ServerTemplateTask) => {
                refreshTemplate();

                return task;
            });
    }

    delete(data: DeleteTaskRequest): Promise<void> {
        return RequestService.delete(`/server-templates/:serverTemplate/schedules/${data.schedule}/tasks/${data.id}`).then(() => {
            refreshTemplate();
        });
    }

    reorder(data: ReorderTasksRequest): Promise<void> {
        return RequestService.put(`/server-templates/:serverTemplate/schedules/${data.schedule}/tasks/reorder`, { order: data.order }).then(() => {
            refreshTemplate();
        });
    }
}

export default new ServerTemplateTasksService();
